import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
    CheckCircle2,
    ArrowRight,
    Bot,
    ScanText,
    TrendingUp,
    ShieldAlert,
    Sparkles,
    Zap
} from 'lucide-react';
import './Solutions.css';
import '../LandingPage.css';

import aiInsightImg from '../../../assets/IA.png';
import tmsLogo from '../../../assets/TmsLogoh.png';

const AI_FEATURES = [
    {
        icon: <Bot size={28} color="#4338ca" />,
        bg: '#eef2ff',
        title: 'Chat IA Conversationnel',
        description: 'Interrogez directement votre TMS. Demandez à l\'IA de trouver une mission, de résumer l\'activité du jour ou d\'analyser une situation spécifique.'
    },
    {
        icon: <ScanText size={28} color="#059669" />,
        bg: '#ecfdf5',
        title: 'Extraction OCR',
        description: 'Ne saisissez plus les permis de conduire manuellement. L\'IA lit les documents scannés et extrait instantanément les informations des chauffeurs.'
    },
    {
        icon: <TrendingUp size={28} color="#b45309" />,
        bg: '#fef9c3',
        title: 'Tarification Intelligente',
        description: 'L\'algorithme analyse vos coûts et l\'historique du marché pour vous suggérer le prix le plus juste et rentable pour chaque mission.'
    },
    {
        icon: <ShieldAlert size={28} color="#dc2626" />,
        bg: '#fef2f2',
        title: 'Détection des fraudes',
        description: 'L\'IA scrute en continu vos données pour repérer les anomalies, détecter les incohérences documentaires et alerter sur les risques de fraude.'
    }
];

const AiAgentCenter = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="saas-container">
            {/* Navbar */}
            <nav className="landing-nav saas-nav">
                <div className="nav-container">
                    <div className="nav-logo">
                        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', textDecoration: 'none' }}>
                            <img src={tmsLogo} alt="Bfret Logo" style={{ height: '32px' }} />
                        </Link>
                    </div>
                    <div className="nav-links">
                        <div className="nav-dropdown">
                            <span className="nav-dropdown-toggle">Solutions</span>
                            <div className="nav-dropdown-menu">
                                <Link to="/solutions/planification-intelligente">Planification intelligente</Link>
                                <Link to="/solutions/suivi-temps-reel">Suivi en temps réel</Link>
                                <Link to="/solutions/documents-centralises">Documents centralisés</Link>
                                <Link to="/solutions/rapports-analytics">Rapports & Analytics</Link>
                                <Link to="/solutions/gestion-ressources">Gestion des ressources</Link>
                                <Link to="/solutions/ai-agent-center">AI Agent Center</Link>
                            </div>
                        </div>
                        <Link to="/contact" className="btn-primary saas-btn-primary" style={{ marginLeft: '1rem' }}>Démo</Link>
                    </div>
                </div>
            </nav>

            {/* Hero */}
            <section style={{ padding: '6rem 5% 4rem', textAlign: 'center', backgroundColor: '#f8fafc', borderBottom: '1px solid #e2e8f0', overflow: 'hidden' }}>
                <span className="saas-feature-tag" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1.5rem', backgroundColor: '#e0e7ff', color: '#4338ca', padding: '0.5rem 1rem', borderRadius: '9999px', fontWeight: '600' }}>
                    <Sparkles size={16} /> Intelligence Artificielle
                </span>
                <h1 style={{ fontSize: '3.5rem', maxWidth: '950px', margin: '0 auto 1.5rem', color: '#0f172a', lineHeight: '1.1' }}>
                    L'IA au service de votre exploitation
                </h1>
                <p style={{ fontSize: '1.25rem', maxWidth: '750px', margin: '0 auto 2.5rem', color: '#475569', lineHeight: '1.6' }}>
                    Découvrez le Centre de Contrôle IA de BFRET. Un véritable assistant digital qui automatise la saisie, optimise vos prix, détecte les anomalies et répond à vos questions en langage naturel.
                </p>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
                    <Link to="/contact" className="saas-btn saas-btn-primary" style={{ padding: '0.875rem 2.5rem', fontSize: '1.1rem', borderRadius: '8px' }}>
                        Demander une démo
                    </Link>
                </div>
            </section>

            {/* 4 AI Modules Grid */}
            <section style={{ padding: '5rem 5%', backgroundColor: '#ffffff' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                    <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
                        <h2 style={{ fontSize: '2.5rem', color: '#0f172a', marginBottom: '1rem' }}>4 modules IA intégrés à votre TMS</h2>
                        <p style={{ fontSize: '1.15rem', color: '#475569', maxWidth: '650px', margin: '0 auto' }}>
                            Notre Agent Center ne se contente pas de vous donner des statistiques, il agit, lit, analyse et interagit avec vous au quotidien.
                        </p>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '1.5rem' }}>
                        {AI_FEATURES.map((feature, i) => (
                            <div key={i} style={{ padding: '2rem', backgroundColor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', gap: '1rem', transition: 'transform 0.2s', cursor: 'default' }}>
                                <div style={{ padding: '0.75rem', backgroundColor: feature.bg, borderRadius: '10px', width: 'fit-content' }}>
                                    {feature.icon}
                                </div>
                                <h3 style={{ fontSize: '1.15rem', color: '#0f172a', margin: 0, fontWeight: '700' }}>{feature.title}</h3>
                                <p style={{ color: '#475569', margin: 0, lineHeight: '1.6', fontSize: '0.97rem' }}>{feature.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Split Section: Chat IA & Data */}
            <section className="saas-feature-section" style={{ paddingTop: '5rem', paddingBottom: '4rem', borderTop: '1px solid #f1f5f9' }}>
                <div className="saas-feature-grid">
                    <div className="saas-feature-text" style={{ paddingRight: '2rem' }}>
                        <span className="saas-feature-tag">L'Assistant IA</span>
                        <h2 style={{ fontSize: '2.5rem', lineHeight: '1.2', marginBottom: '1.5rem', color: '#0f172a' }}>
                            Posez vos questions, l'IA s'occupe du reste
                        </h2>
                        <p style={{ fontSize: '1.15rem', color: '#475569', marginBottom: '2.5rem', lineHeight: '1.6' }}>
                            Gagnez un temps précieux en interagissant avec votre TMS comme avec un collaborateur. Posez vos questions en langage naturel et obtenez des analyses immédiates.
                        </p>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                            <div>
                                <h3 style={{ fontSize: '1.25rem', display: 'flex', alignItems: 'center', gap: '0.75rem', color: '#0f172a', marginBottom: '0.5rem' }}>
                                    <CheckCircle2 size={24} color="var(--saas-primary)" />
                                    Analyse de rentabilité
                                </h3>
                                <p style={{ fontSize: '1.05rem', color: '#475569', margin: 0, paddingLeft: '2.25rem' }}>
                                    L'IA consolide instantanément les marges et coûts de vos missions pour vous donner une vision claire de votre rentabilité.
                                </p>
                            </div>
                            <div>
                                <h3 style={{ fontSize: '1.25rem', display: 'flex', alignItems: 'center', gap: '0.75rem', color: '#0f172a', marginBottom: '0.5rem' }}>
                                    <CheckCircle2 size={24} color="var(--saas-primary)" />
                                    Aide à l'affectation
                                </h3>
                                <p style={{ fontSize: '1.05rem', color: '#475569', margin: 0, paddingLeft: '2.25rem' }}>
                                    Laissez l'algorithme croiser les plannings et les qualifications pour vous suggérer le meilleur chauffeur pour une mission.
                                </p>
                            </div>
                            <div>
                                <h3 style={{ fontSize: '1.25rem', display: 'flex', alignItems: 'center', gap: '0.75rem', color: '#0f172a', marginBottom: '0.5rem' }}>
                                    <CheckCircle2 size={24} color="var(--saas-primary)" />
                                    Gestion des incidents
                                </h3>
                                <p style={{ fontSize: '1.05rem', color: '#475569', margin: 0, paddingLeft: '2.25rem' }}>
                                    En cas d'aléa remonté du terrain, l'IA qualifie l'incident et vous aide à prendre la meilleure décision correctrice.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="saas-feature-visual" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <div style={{ position: 'relative' }}>
                            <div style={{ position: 'absolute', inset: '-10px', background: 'linear-gradient(135deg, #e0e7ff, #f3e8ff, #e0e7ff)', filter: 'blur(30px)', opacity: '0.6', borderRadius: '20px', zIndex: 0 }}></div>
                            <img 
                                src={aiInsightImg} 
                                alt="Aperçu des insights IA BFRET" 
                                style={{ 
                                    position: 'relative',
                                    zIndex: 1,
                                    width: '100%', 
                                    maxWidth: '650px',
                                    borderRadius: '16px', 
                                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                                    border: '1px solid rgba(0,0,0,0.05)'
                                }} 
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* Feature Highlight: OCR & Pricing */}
            <section style={{ padding: '5rem 5%', backgroundColor: '#f8fafc', borderTop: '1px solid #e2e8f0' }}>
                <div style={{ maxWidth: '1000px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '3rem' }}>
                    <div style={{ padding: '3rem', backgroundColor: '#ffffff', borderRadius: '16px', border: '1px solid #e2e8f0', boxShadow: '0 10px 30px -10px rgba(0,0,0,0.05)' }}>
                        <div style={{ padding: '1rem', backgroundColor: '#ecfdf5', borderRadius: '12px', width: 'fit-content', marginBottom: '1.5rem' }}>
                            <ScanText size={32} color="#059669" />
                        </div>
                        <h3 style={{ fontSize: '1.75rem', color: '#0f172a', marginBottom: '1rem' }}>Saisie automatique OCR</h3>
                        <p style={{ color: '#475569', lineHeight: '1.6', fontSize: '1.1rem', marginBottom: '1.5rem' }}>
                            Transformez un simple scan de permis de conduire en données exploitables instantanément. L'IA extrait le nom, le numéro de permis et les dates de validité sans aucune saisie manuelle.
                        </p>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#059669', fontWeight: '600' }}>
                            <Zap size={18} /> Zéro erreur de saisie
                        </div>
                    </div>

                    <div style={{ padding: '3rem', backgroundColor: '#ffffff', borderRadius: '16px', border: '1px solid #e2e8f0', boxShadow: '0 10px 30px -10px rgba(0,0,0,0.05)' }}>
                        <div style={{ padding: '1rem', backgroundColor: '#fef9c3', borderRadius: '12px', width: 'fit-content', marginBottom: '1.5rem' }}>
                            <TrendingUp size={32} color="#b45309" />
                        </div>
                        <h3 style={{ fontSize: '1.75rem', color: '#0f172a', marginBottom: '1rem' }}>Pricing IA</h3>
                        <p style={{ color: '#475569', lineHeight: '1.6', fontSize: '1.1rem', marginBottom: '1.5rem' }}>
                            Notre modèle prédictif génère automatiquement des propositions de prix pour vos missions non-tarifées en se basant sur la distance, le véhicule et l'historique, que vous pouvez valider en un clic.
                        </p>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#b45309', fontWeight: '600' }}>
                            <Zap size={18} /> Facturation accélérée
                        </div>
                    </div>
                </div>
            </section>

            {/* Footer CTA */}
            <section className="saas-hero" style={{ padding: '6rem 5%', textAlign: 'center', backgroundColor: '#ffffff' }}>
                <h2 style={{ fontSize: '2.5rem', marginBottom: '1.5rem', color: '#0f172a' }}>Passez à la logistique 2.0</h2>
                <p style={{ maxWidth: '600px', margin: '0 auto 2.5rem', fontSize: '1.15rem', color: '#475569', lineHeight: '1.6' }}>
                    Gagnez en productivité et laissez l'Intelligence Artificielle gérer les tâches chronophages de votre exploitation.
                </p>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
                    <Link to="/contact" className="saas-btn saas-btn-primary" style={{ padding: '1rem 2.5rem', fontSize: '1.15rem', borderRadius: '8px' }}>
                        Contacter notre équipe <ArrowRight size={20} style={{ marginLeft: '0.5rem' }} />
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default AiAgentCenter;
